import * as React from "react";
const SvgFiBrandsBridgestone = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 25 24"
    {...props}
  >
    <g fill="#151A2D" clipPath="url(#fi-brands-bridgestone_svg__a)">
      <path d="M3.072 13.55 6.128 3.26C6.424 2.2 7.644 1.235 8.875 1.235h9.348a.15.15 0 0 1 .085.275c-4.86 3.194-10.723 7.933-14.97 12.174-.113.112-.31.022-.266-.133M10.456 19.73l3.025-10.157c.045-.154-.128-.266-.257-.16C8.773 13.09 3.404 18.459.043 22.52c-.086.104-.042.26.105.26h13.094c5.522 0 8.543-1.643 9.64-5.567.893-3.195-.853-5.376-3.638-5.936-.05-.01-.094-.1 0-.116 2.355-.386 4.733-1.297 5.58-4.596.917-3.571-1.926-5.528-5.198-5.326l-5.004 16.82c-.27.91-1.284 1.674-2.247 1.674h-1.919z" />
    </g>
    <defs>
      <clipPath id="fi-brands-bridgestone_svg__a">
        <path fill="#fff" d="M0 0h25v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiBrandsBridgestone;
